var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaskCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21.671,
    viewBox: "0 0 22 21.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vote-14",
    transform: "translate(-46.544 -53.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20765",
    "data-name": "Path 20765",
    d: "M68.379,73.772a1,1,0,0,0-.878-.439H58.943l8.12-8.12a3.74,3.74,0,0,0,1.207-2.743,3.929,3.929,0,0,0-1.207-2.743l-5.047-5.047a3.974,3.974,0,0,0-5.6,0L47.97,63.128a4.194,4.194,0,0,0,0,5.6l4.718,4.608H47.312a.848.848,0,0,0-.768.878.961.961,0,0,0,.768.988H67.5a1,1,0,0,0,.878-.439.823.823,0,0,0,0-.988Zm-12.618-.658a2.166,2.166,0,0,1-1.536-.658l-5.047-5.047a2.121,2.121,0,0,1,0-3.072l8.559-8.449a2.166,2.166,0,0,1,1.536-.658,1.769,1.769,0,0,1,1.426.658l5.047,5.047a2.121,2.121,0,0,1,0,3.072L57.3,72.455a2.166,2.166,0,0,1-1.536.658Z",
    transform: "translate(0 0)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20766",
    "data-name": "Path 20766",
    d: "M306.34,408.684l-4.389,4.389-2.414-2.414a1,1,0,0,0-1.317,0,.823.823,0,0,0,0,1.317l3.072,2.963a.948.948,0,0,0,.658.329.4.4,0,0,0,.329-.11c.11,0,.219-.11.329-.11L307.656,410a.823.823,0,0,0,0-1.317,1,1,0,0,0-1.317,0Z",
    transform: "translate(-245.422 -346.543)",
    fill: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskCenter);
export default __webpack_public_path__ + "static/media/task-center.aa2da2f85aa4dcaf52609c425ca87620.svg";
export { ForwardRef as ReactComponent };